import { render, staticRenderFns } from "./LevelConfigs.vue?vue&type=template&id=b09cefb2&scoped=true&"
import script from "./LevelConfigs.vue?vue&type=script&lang=js&"
export * from "./LevelConfigs.vue?vue&type=script&lang=js&"
import style0 from "./LevelConfigs.vue?vue&type=style&index=0&id=b09cefb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09cefb2",
  null
  
)

export default component.exports